export const SUB_ADMIN_ROLES = ['superadmin', 'admin', 'operator', 'accounting', 'sales', 'document'];
